/**
 * This is the Fallback component to render till the module is ready.
 */
export default function FallbackDialogScheduleSettings() {
  return null;
}